module.exports = __webpack_public_path__ + "img/maingau-logo@2x.b2651515.webp";